/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */

import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import { createCsvForStylist, makeCommissionObj, transformCommissionRate, translatedCategories, translatedHeaders } from 'reports/Commissions/utils';
import { DownloadExcelButton } from 'reports/Common/DownloadExcelButton';
import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './RevenueCommissionTable.module.scss';

const colWidth = '140px';

class RevenueCommissionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commissionForAllStylist: {},
    };
  }

  componentDidMount() {
    let commissionArr = [];
    if (this.props.allCommissionReport) {
      if (Object.keys(this.props.allCommissionReport).length) {
        commissionArr = Object.entries(this.props.allCommissionReport);
      }
    }

    this.props.data.map((rev) => {
      const categories = rev.categories;
      const products = rev.products;
      const id = rev.id;
      const revenue_from_no_shows = rev.revenue_from_no_shows;
      const revenue_from_products = rev.revenue_from_products;
      const oneCommission = commissionArr.filter((c) => c[0] === rev.name);
      let commission;
      if (oneCommission.length > 0) {
        commission = oneCommission[0];
      }
      setTimeout(() => {
        this.makeCommissionArr(categories, products, commission, revenue_from_no_shows, revenue_from_products, id, rev.name);
      }, 0);
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let commissionArr = [];
    if (nextProps.allCommissionReport) {
      if (Object.keys(nextProps.allCommissionReport).length) {
        commissionArr = Object.entries(nextProps.allCommissionReport);
      }
    }

    nextProps.data.map((rev) => {
      const categories = rev.categories;
      const products = rev.products;
      const id = rev.id;
      const revenue_from_no_shows = rev.revenue_from_no_shows;
      const revenue_from_products = rev.revenue_from_products;
      const oneCommission = commissionArr.filter((c) => c[0] === rev.name);
      let commission;
      if (oneCommission.length > 0) {
        commission = oneCommission[0];
      }
      setTimeout(() => {
        this.makeCommissionArr(categories, products, commission, revenue_from_no_shows, revenue_from_products, id, rev.name);
      }, 0);
    });
  }

  makeCommissionArr = (categories, products, commissionArray, revenue_from_no_shows, revenue_from_products, stylistId, stylistName) => {
    const commissionObj = makeCommissionObj(categories, products, commissionArray, revenue_from_no_shows, revenue_from_products, stylistId, stylistName, this.props.t);
    const copyOfCommissionForAllStylist = Object.assign({}, this.state.commissionForAllStylist);
    copyOfCommissionForAllStylist[stylistName] = commissionObj;
    this.setState({ commissionForAllStylist: copyOfCommissionForAllStylist });
  };

  render() {
    const commissionsArr = Object.entries(this.state.commissionForAllStylist);
    const TABLE_HEADERS = translatedHeaders(this.props.t);
    const NO_TYPE_CATEGORY = translatedCategories(this.props.t);

    const allCategories = {};

    for (const [, data] of commissionsArr) {
      for (const [catName, catData] of Object.entries(data)) {
        if (!allCategories[catName]) {
          allCategories[catName] = {
            catName,
            object_type: catData?.object_type || null,
          };
        }
      }
    }

    // normal categories with object_type
    const normalCategories = Object.values(allCategories)
      .filter((c) => c.object_type)
      .map((c) => c.catName);

    // all categories + 'Total Services' and 'Total' at the end in a specific order
    const categoriesArray = [...normalCategories, NO_TYPE_CATEGORY.totalServicesName, NO_TYPE_CATEGORY.totalName];

    return (
      <div id="commissions-stylist" className={CN.component}>
        <div className="t-bgr fullWidth">
          <div className="t-wrap">
            <h2>{this.props.t('businessReports.commissions.totalBusinessRevenueShare')}</h2>
            <div className="t-discount">
              <table
                className={cn({
                  businessSummaryTable: true,
                  [CN.boldFooterRow]: true,
                })}
              >
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <div className="date-in-tbl-for-export">
                        {this.props.t('businessReports.commissions.fromDate')} <strong>{this.props.startDate}</strong> {this.props.t('businessReports.commissions.toDate')}{' '}
                        <strong>{this.props.endDate}</strong>
                      </div>
                    </td>
                  </tr>
                  <tr className="t-h first-row">
                    <th className="a3 h" style={{ width: '220px' }}>
                      {TABLE_HEADERS.categories}
                    </th>
                    <th className="a3 text-r" style={{ width: colWidth, paddingLeft: '20px' }}>
                      <span className="column-title">{this.props.t('businessReports.commissions.businessRevenueShare')}</span>
                    </th>
                    <th style={{ width: 'auto' }} />
                  </tr>
                  {categoriesArray.map((cat) => {
                    const totalShare = commissionsArr.reduce((sum, [, data]) => sum + (data[cat]?.businessShare || 0), 0);
                    if (totalShare === 0) return null;
                    return (
                      <tr className="t-h" key={cat}>
                        <td className="stylist-name">{cat}</td>
                        <td className="t-value">
                          <CurrencySign /> {convertToMoneyAfterVat(totalShare)}
                        </td>
                        <td />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {[...commissionsArr].map((commission, index) => {
          const [stylistName, data] = commission || [];
          return (
            <div key={`${index}-${stylistName}`} className="t-bgr fullWidth">
              <div className="t-wrap">
                <div className={CN.tableHeader}>
                  <h2>{stylistName}</h2>
                  <DownloadExcelButton
                    getCsvData={() => createCsvForStylist(data, this.props.t, this.props.currency)}
                    fileName={this.props.t('businessReports.commissions.commissionFor', { stylist: stylistName })}
                    disabled={!data}
                  />
                </div>
                <div className="t-discount cfix not-footer">
                  <table
                    id={`table-to-xls-${stylistName}`}
                    className={cn({
                      'discount-tbl with-input-percent': true,
                      [CN.boldFooterRow]: true,
                    })}
                  >
                    <tbody>
                      <tr>
                        <td colSpan="3">
                          <div className="date-in-tbl-for-export">
                            {this.props.t('businessReports.commissions.fromDate')}
                            {S.space}
                            <strong>{this.props.startDate}</strong> {this.props.t('businessReports.commissions.toDate')}
                            {S.space}
                            <strong>{this.props.endDate}</strong>
                          </div>
                        </td>
                      </tr>
                      <tr className="t-h first-row">
                        <th className="a3 h" style={{ width: '220px' }}>
                          {TABLE_HEADERS.categories}
                        </th>
                        <th className="a3 text-r" style={{ width: '120px', paddingLeft: '20px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.revenueExclTips}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.staffCommission}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLE_HEADERS.staffRevenue}</span>
                        </th>
                        <th className="a3 text-r" style={{ width: colWidth }}>
                          <span className="column-title">{TABLE_HEADERS.businessRevenue}</span>
                        </th>
                        <th style={{ width: 'auto' }} />
                      </tr>
                      {commission &&
                        Object.entries(data).length > 0 &&
                        Object.entries(data).map((cat) => (
                          <tr className="t-h" key={`${cat[0]}`}>
                            <td className="stylist-name">{cat[0]}</td>
                            <td data-bem="RevenueCommissionTable-revenue-excl-tips" className="t-value">
                              <CurrencySign />
                              {convertToMoneyAfterVat(cat[1].ItemRevenue)}
                            </td>
                            <td className="t-value low">{transformCommissionRate(cat[1].commissionRate)}</td>
                            <td data-bem="RevenueCommissionTable-staff-revenue-share" className="t-value" style={{ paddingLeft: '34px' }}>
                              <CurrencySign /> {convertToMoneyAfterVat(cat[1].commission)}
                            </td>
                            <td data-bem="RevenueCommissionTable-business-revenue-share" className="t-value" style={{ paddingLeft: '34px' }}>
                              <CurrencySign /> {convertToMoneyAfterVat(cat[1].businessShare)}
                            </td>
                            <td />
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          );
        })}
        <br /> <br /> <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const RevenueCommissionTableHoc = connect(mapStateToProps)(withTranslation()(RevenueCommissionTable));

export default RevenueCommissionTableHoc;
